'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTaskLog', ['$scope', '$stateParams', 'LicenseScheduledTaskLogs', 'LicenseCategories', function ($scope, $stateParams, LicenseScheduledTaskLogs, LicenseCategories) {
        $scope.resetLicense();
        $scope.scheduledTaskLogID = $stateParams.scheduledTaskLogID;

        $scope.scheduledTaskLogsLoading = true;
        $scope.isLogRecordsOpen = true;

        $scope.scheduledTaskLogLoading = true;
        $scope.isLogRecordValuesOpen = true;

        if ($scope.scheduledTaskLogID) {
            LicenseScheduledTaskLogs.getByID($scope.scheduledTaskLogID).then(function (scheduled_task_log_values) {
                $scope.scheduled_task_log_values = scheduled_task_log_values;
                $scope.scheduledTaskLogLoading = false;
            });
        } else {
            LicenseScheduledTaskLogs.get({ scheduledTaskID: $scope.scheduledTaskID }).then(function (scheduled_task_logs) {
                $scope.scheduled_task_logs = scheduled_task_logs;
                $scope.scheduledTaskLogsLoading = false;
            });
        };

        $scope.columns = [
            {
                label: 'Date',
                field: 'created_on',
                type: 'date',
                link: {
                    state: 'internal.licensing.license.scheduledtask.log',
                    params: [
                        {
                            name: 'scheduledTaskLogID',
                            field: 'id'
                        },
                        {
                            name: 'licenseCategoryID',
                            field: 'license_category_id'
                        }

                    ]
                }
            },
            {
                label: 'Start Time',
                field: 'start_time',
                type: 'datetime'
            },
            {
                label: 'End Time',
                field: 'end_time',
                type: 'datetime'
            },
            {
                label: 'Records',
                field: 'record_count',
                type: 'int'
            },
            {
                label: 'Status',
                field: 'status',
                type: 'text'
            }
        ];

        $scope.filters = [
            {
                name: 'Date',
                field: 'created_on',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ];

        LicenseCategories.getByID($scope.licenseCategoryID).then(function (licenseCategory) {
            if (licenseCategory.vehicle_entity == true) {
                $scope.variablelabel = $scope.enterprise.vehicleLabels["VEHICLE"] + ' Certification Record';
            }
            else if (licenseCategory.service_entity == true) {
                $scope.variablelabel = $scope.enterprise.serviceLabels["SERVICE"] + ' Certification Record';
            }
            else if (licenseCategory.user_entity == true) {
                $scope.variablelabel = $scope.enterprise.userLabels["USER"] + ' Certification Record';
            }
            else {
                $scope.variablelabel = 'Entity Certification Record';
            }

            $scope.valueColumns = [
                {
                    label: $scope.variablelabel,
                    field: 'entity',
                    type: 'text',
                    cfvariableurl: 'certification_url',
                    cfparam: 'entity_id'
                },
                {
                    label: 'Certification Number',
                    field: 'certification_number',
                    type: 'text'
                },
                {
                    label: 'Certification Status',
                    field: 'certification_status',
                    type: 'text'
                },
                {
                    label: 'Certification Level',
                    field: 'certification_level',
                    type: 'text'
                },
                {
                    label: 'Certification Issue Date',
                    field: 'certification_issue_date',
                    type: 'date'
                },
                {
                    label: 'Certification Expiration Date',
                    field: 'certification_expiration_date',
                    type: 'date'
                },
                {
                    label: 'Status',
                    field: 'status',
                    type: 'text'
                }
            ];
        });
    }]);